var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconChinaFutureTech = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 23,
  height: 23,
  viewBox: "0 0 23 23",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16.8785 1.87881C18.0501 0.707233 19.9497 0.707 21.1213 1.87849C22.2929 3.05007 22.2929 4.94997 21.1213 6.12155C19.9497 7.29299 18.0501 7.29276 16.8785 6.12122C15.7072 4.94969 15.7072 3.05035 16.8785 1.87881Z",
  stroke: "white",
  strokeWidth: 2
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.8785 16.8788C18.0501 15.7072 19.9497 15.707 21.1213 16.8785C22.2929 18.0501 22.2929 19.95 21.1213 21.1215C19.9497 22.293 18.0501 22.2928 16.8785 21.1212C15.7072 19.9497 15.7072 18.0503 16.8785 16.8788Z",
  stroke: "white",
  strokeWidth: 2
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M1.87855 16.8787C3.05008 15.7071 4.9497 15.7069 6.12128 16.8784C7.29291 18.05 7.29291 19.9499 6.12128 21.1215C4.9497 22.2929 3.05008 22.2927 1.87855 21.1211C0.707151 19.9496 0.707151 18.0503 1.87855 16.8787Z",
  stroke: "white",
  strokeWidth: 2
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M2.00355 2.37858C3.17508 1.207 5.0747 1.20677 6.24628 2.37826C7.41791 3.54984 7.41791 5.44974 6.24628 6.62132C5.0747 7.79276 3.17508 7.79253 2.00355 6.62099C0.832151 5.44946 0.832151 3.55012 2.00355 2.37858Z",
  stroke: "white",
  strokeWidth: 2
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M18.25 4.99982H5.25V17.9998H18.25V4.99982Z",
  stroke: "white",
  strokeWidth: 2
})));
export default SvgIconChinaFutureTech;